import { render } from "./Settledstudents.vue?vue&type=template&id=cfff24fc"
import script from "./Settledstudents.vue?vue&type=script&lang=js"
export * from "./Settledstudents.vue?vue&type=script&lang=js"

import "./Settledstudents.vue?vue&type=style&index=0&id=cfff24fc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__